import { ActivityType } from '@evidentid/tprm-portal-lib/models/activity-history';

export const SUBMISSION_HISTORY_ACTIVITY_TYPES: ActivityType[] = [
    ActivityType.REQUEST_CREATED,
    ActivityType.RESPONSE_RECEIVED,
    ActivityType.RESPONSE_COLLECTED,
    ActivityType.REQUEST_TIMEOUT,
    ActivityType.REQUEST_TERMINATED,
    ActivityType.EVALUATION_COMPLETED,
    ActivityType.FORCED_SUBMISSION,
];
